import React from "react";
import { Link, useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";

export default function AdminInvoiceCategories() {
  const history = useHistory();

  const table_columns = [
    { header: "Name", key: "name" },
    { header: "Description", key: "description" },
    { header: "QuickBooks Account", key: "qb_account" },
    { header: "QuickBooks Invoice Item", key: "qb_invoice_item" },
    { header: "Channel Option(s)", key: "channel_options", render: (channels) => {
      return channels.channel_options.map((option) => {
        return <div key={option.id} style={{minWidth: "200px"}}>&bull; {option.name}</div>
      })
    }},
    { header: "Unit Price", key: "unit_price" },
    { header: "Base Record or Addon", key: "invoice_category_type" },
  ];

  const table_actions = (invoice_category) => (
    <ul id="action-menu" className="action-menu">
      <Link
        to={"/admin-invoice-category-form#invoice_category_id=" + invoice_category.id}
      >
        {" "}
        <i className="bi bi-pencil"></i>Edit
      </Link>
    </ul>
  );

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  function onClickNew(ev) {
    ev.stopPropagation();
    history.push("/admin-invoice-category-form");
  }

  function onClickManageSuppressions() {
    history.push("/admin-suppress-invoice-category");
  }

  return (
    <div className="page admin-page admin-invoice-categories-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"></i> Admin
        </button>
        <h1>Invoice Categories</h1>
        <i className="spacer" />
        <button className="new-button" onClick={onClickManageSuppressions}>
          Manage Suppressions
        </button>
        <button className="new-button" onClick={onClickNew}>
          New Invoice Category
        </button>
      </div>
      <div className="invoice-categories">
        <DataTable
          query="admin/invoice_categories"
          cols={table_columns}
          actions={table_actions}
          empty="No Invoice Categories Found"
          params={{
            sort_asc: true
          }}
        />
      </div>
    </div>
  );
}
